module.exports = __webpack_public_path__ + "static/media/Derek Deike.181fbecd.png";